import React, { useState } from 'react'
import { saveWLProfile } from '../../../../api/userApi';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import LoadingButton from '../../../../components/global-components/loading-btn';
import { Alert, Box, Dialog, DialogContent, DialogTitle, FormHelperText, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';
import { getGTMId, validateGTMID } from '../../../../helpers';
import { useAuth } from '../../../../helpers/context';

export default function ConnectWithGTM({ WlUser, onOK, GTMId, setGTMId }) {
    
    const [isSubmittingGTM, setIsSubmittingGTM] = useState(false);
    const [GTMError, setGTMError] = useState('');
    const [openGTMStepsDialog, setOpenGTMStepsDialog] = useState(false);
    const [extractGTMID, setExtractGTMID] = useState(false);
    const [GTMCode, setGTMCode] = useState('');
    const [newGTMId, setNewGTMId] = useState('');
    const { t, i18n } = useTranslation();
    const { token } = useAuth();

    const saveGTMID = (event, code) => {
        event.preventDefault();
        setExtractGTMID(false);
        if (GTMId && !validateGTMID(GTMId)) {
            setGTMError(t("PleaseEnterAValidID"));
            return;
        }
        setIsSubmittingGTM(true);
        saveWLProfile({
            ...WlUser,
            userId: token,
            // whatsapp: resolvePhonePrefix(number),
            language: i18n.language === 'ar' ? '0' : '1',
            gtm_container: code || GTMId
        }).then(result => {
            if (result.resCode === 0) {
                toast.success(t("LinkedSuccessfully"));
                setNewGTMId('');
                onOK();
            } else {
                toast.error(result.resStr);
            }
        }).finally(() => setIsSubmittingGTM(false));
    }
    
    const unLinkGTM = (event) => {
        event.preventDefault();
        setIsSubmittingGTM(true);
        saveWLProfile({
            ...WlUser,
            userId: token,
            // whatsapp: resolvePhonePrefix(number),
            language: i18n.language === 'ar' ? '0' : '1',
            gtm_container: ''
        }).then(result => {
            if (result.resCode === 0) {
                toast.success(t("UnLinkedSuccessfully"));
                onOK();
                setGTMId("");
                setNewGTMId("");
            } else {
                toast.error(result.resStr);
            }
        }).finally(() => setIsSubmittingGTM(false));
    }
    
    return (
        <>
            <div className='custom-card with-switcher' style={{ minHeight: 'auto' }}>
                <div className="card-header">
                    <div className="d-flex flex-row justify-content-start align-items-center" style={{ gap: '10px' }}>
                        <img alt="gtm logo" src="/assets/img/logo/gtm-logo.png" width={50} height={50} />
                        <div>
                            <h4>{t("LinkWithGTM")}</h4>
                            <h6>{t("LinkWithGTMDesc")}</h6>
                        </div>
                    </div>
                    {newGTMId && (
                        <LoadingButton
                            classes="mt-3 mt-md-0 primary-btn py-2 px-3"
                            handleClick={saveGTMID}
                            OKdisabled={!GTMId}
                            label={t("ActivateLinking")}
                            loading={isSubmittingGTM}
                        />
                    )}
            
                </div>
                <div className="card-body">
                    <div className="row mx-0">
                        {GTMId && !newGTMId ? (
                            <Alert
                                sx={{ "& .MuiAlert-message": { width: "100%" } }}
                                severity='success'
                                className='custom-alert2 custom-alert w-100 align-items-center'
                            >
                                <div className='w-100 d-flex justify-content-between align-items-md-center flex-column flex-md-row'>
                                    <span>
                                        {t("LinkedWithGTMDesc", { id: GTMId })}
                                    </span>
                                    <LoadingButton
                                        style={{
                                            width: "fit-content",
                                            borderColor: "#222",
                                            color: "#222",
                                        }}
                                        classes='btn primary-btn mt-2 mt-md-0 delete-btn'
                                        variant='outlined'
                                        handleClick={(e) => unLinkGTM(e)}
                                        loading={isSubmittingGTM}
                                        label={t("Unlink")}
                                    />
                                </div>
                            </Alert>
                        ) : (
                            <>
                                <div className="col-12 p-0">
                                    <p>
                                        {t("YouCanViewTheLinkingSteps")}
                                        <span
                                            style={{ textDecoration: 'underline', color: 'var(--main-color-one)', cursor: 'pointer', fontWeight: 600 }}
                                            onClick={() => setOpenGTMStepsDialog(true)}>
                                            {t("FromHere")}
                                        </span>
                                    </p>
                                </div>
                                <div className="col-12 p-0 mt-2">
                                    <TextField
                                        label={t("GTMID")}
                                        sx={{ direction: 'ltr', textAlign: 'left' }}
                                        variant='outlined'
                                        InputLabelProps={{ shrink: true }}
                                        placeholder="GTM-XXXXXXXX"
                                        fullWidth
                                        className='mt-4'
                                        value={GTMId}
                                        onChange={(v) => {
                                            v.preventDefault();
                                            let code = getGTMId(v.currentTarget.value);
                                            setGTMId(code);
                                            // if (!validateGTMID(code)) {
                                            setNewGTMId(code);
                                            // } else {
                                            //   saveGTMID(v, code);
                                            // }
                                            setGTMError('');
                                        }}
                                    />
                                    <p style={{ color: 'var(--main-color-one)', cursor: 'pointer', fontWeight: 500 }} className="my-2" onClick={() => setExtractGTMID(true)}>{t("ExtractIDByCode")}</p>
                                    {GTMError &&
                                        <FormHelperText component={Box}>
                                            <Alert severity="error" className="custom-alert">
                                                {GTMError}
                                            </Alert>
                                        </FormHelperText>
                                    }
                                    {extractGTMID && (
                                        <>
                                            <button className="outlined-btn btn py-1 mt-3" style={{ height: '35px' }} onClick={() => setExtractGTMID(false)}>{t("Hide")}</button>
                                            <TextField
                                                sx={{ width: "100%", '& .MuiInputBase-root': { direction: 'ltr' }, '& textarea': { direction: 'ltr', textAlign: 'left', textAlignLast: 'left' } }}
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                multiline
                                                rows={7}
                                                value={GTMCode}
                                                className='my-2'
                                                onChange={(v) => {
                                                    v.preventDefault();
                                                    setGTMCode(v.currentTarget.value);
                                                }}
                                            />
                                            <button className="primary-btn btn py-1" style={{ height: '35px' }} onClick={(e) => {
                                                if (validateGTMID(getGTMId(GTMCode))) {
                                                    setGTMId(getGTMId(GTMCode));
                                                    // setNewGTMId(getGTMId(GTMCode));
                                                    setGTMError('');
                                                    setExtractGTMID(false);
                                                    saveGTMID(e, getGTMId(GTMCode));
                                                } else {
                                                    setGTMError(t("PleaseEnterAValidID"));
                                                }
                                            }}>{t("Extract")}</button>
                                        </>
                                    )}
                
                                </div>
                            </>
                        )}
            
                    </div>
                </div>
            </div>
            <Dialog
                fullWidth={true}
                maxWidth={"md"}
                open={openGTMStepsDialog}
                className="custom-dialog model"
                onClose={() => setOpenGTMStepsDialog(false)}>
                <DialogTitle>
                    <div className="dialog-head">
                        <div>
                            <h2>{t("GTMLinkingSteps")}</h2>
                        </div>
                        <div className="dialog-actions">
                            <span onClick={() => setOpenGTMStepsDialog(false)} style={{ cursor: 'pointer' }}>
                                <Close />
                            </span>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '15px', fontSize: '14px', maxWidth: '100%' }}>
                        <h5 style={{ color: 'var(--main-color-one)' }}>{t("GTMStep01")}</h5>
                        <p>1. {t("GTMStep03-1")}<a href="https://tagmanager.google.com/#/home" style={{ textDecoration: 'underline', color: 'var(--main-color-one)' }}>Google Tag Manager</a> {t("GTMStep03-2")}</p>
                        <img src="/assets/img/others/gtm/step-01.png" alt="step-01" className="mb-5 d-block" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p>2. {t("GTMStep04")}</p>
                        <img src="/assets/img/others/gtm/step-02.png" alt="step-02" className="d-block mb-3" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p>1- {t("GTMStep04-1")}</p>
                        <p>2- {t("GTMStep04-2")}</p>
                        <p className="mb-5">3- {t("GTMStep04-3")}</p>

                        <p>3. {t("GTMStep05")}</p>
                        <img src="/assets/img/others/gtm/step-03.png" alt="step-03" className="d-block mb-3" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p>1- {t("GTMStep05-1")}</p>
                        <p>2- {t("GTMStep05-2")} ({t("GTMStep05-3")})</p>
                
                        <p className="mt-5">4. {t("GTMStep06")}</p>
                        <img src="/assets/img/others/gtm/step-04.png" alt="step-04" className="d-block" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p className="mt-5">5. {t("GTMStep07")}</p>
                        <img src="/assets/img/others/gtm/step-05.png" alt="step-05" className="d-block" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />

                        <h5 style={{ color: 'var(--main-color-one)' }} className="my-5">{t("GTMStep08")}</h5>
                        <p>1. {t("GTMStep09")}</p>
                        <p>2. {t("GTMStep10")}</p>
                        <img src="/assets/img/others/gtm/step-06.png" alt="step-06" className="d-block" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p className="mt-5">3. {t("GTMStep11")}</p>
                        <img src="/assets/img/others/gtm/step-07.png" alt="step-07" className="d-block mb-3" style={{ width: '100%', border: '1px solid #ccc', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }} />
                        <p className="mt-5">{t("GTMStep12")}</p>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}
